var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAlertOrangeIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#FFB32F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 26,
    cy: 26.0035,
    r: 17.6129,
    fill: "#FFB32F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4259 33.4375C18.2731 33.4375 18.1342 33.3993 18.0092 33.3229C17.8841 33.2465 17.7869 33.1458 17.7175 33.0208C17.648 32.8958 17.6098 32.7604 17.6029 32.6146C17.5959 32.4688 17.6341 32.3264 17.7175 32.1875L25.4269 18.8542C25.5103 18.7153 25.6179 18.6111 25.7499 18.5417C25.8819 18.4722 26.0173 18.4375 26.1562 18.4375C26.2951 18.4375 26.4306 18.4722 26.5625 18.5417C26.6945 18.6111 26.8021 18.7153 26.8855 18.8542L34.595 32.1875C34.6783 32.3264 34.7165 32.4688 34.7096 32.6146C34.7026 32.7604 34.6644 32.8958 34.595 33.0208C34.5255 33.1458 34.4283 33.2465 34.3033 33.3229C34.1783 33.3993 34.0393 33.4375 33.8865 33.4375H18.4259ZM26.1562 30.9375C26.3924 30.9375 26.5903 30.8576 26.7501 30.6979C26.9098 30.5382 26.9897 30.3403 26.9897 30.1042C26.9897 29.8681 26.9098 29.6701 26.7501 29.5104C26.5903 29.3507 26.3924 29.2708 26.1562 29.2708C25.9201 29.2708 25.7221 29.3507 25.5624 29.5104C25.4026 29.6701 25.3228 29.8681 25.3228 30.1042C25.3228 30.3403 25.4026 30.5382 25.5624 30.6979C25.7221 30.8576 25.9201 30.9375 26.1562 30.9375ZM26.1562 28.4375C26.3924 28.4375 26.5903 28.3576 26.7501 28.1979C26.9098 28.0382 26.9897 27.8403 26.9897 27.6042V25.1042C26.9897 24.8681 26.9098 24.6701 26.7501 24.5104C26.5903 24.3507 26.3924 24.2708 26.1562 24.2708C25.9201 24.2708 25.7221 24.3507 25.5624 24.5104C25.4026 24.6701 25.3228 24.8681 25.3228 25.1042V27.6042C25.3228 27.8403 25.4026 28.0382 25.5624 28.1979C25.7221 28.3576 25.9201 28.4375 26.1562 28.4375Z",
    fill: "#FFB32F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlertOrangeIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alert-orange-icon.8237658f.svg";
export { ForwardRef as ReactComponent };